// extracted by mini-css-extract-plugin
export default {"noResultsMessage":"_3Y8Qb","nextResultsMessage":"_3MXK3","messageWithMarginTop":"_1-gS3"};